const css = `@keyframes Pu1I6W__wiggle{20%{transform:translate(4px)}40%{transform:translate(-4px)}60%{transform:translate(2px)}80%{transform:translate(-1px)}to{transform:translate(0)}}.Pu1I6W__container{box-sizing:border-box;height:100vh;width:100%;justify-content:center;align-items:stretch;display:flex;position:absolute;top:0}.Pu1I6W__content{background-color:var(--base-backgrounds-default);flex-direction:column;flex:1;display:flex}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"wiggle":"Pu1I6W__wiggle","content":"Pu1I6W__content","container":"Pu1I6W__container"};
